import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Spin } from 'antd';
import store from 'store';
import { logout } from '../store/actions/index.js';
import { Ajax } from '../components/Ajax';
import { ApiUrl, AppPages, StoreKeys } from '../project/Defines';
import { Project } from '../project/Project.js';

/**
 * the Logout Component
 * @exports Logout
 */
function Logout(props) {
    
    useEffect(() => {
        let history = props.history;
        if (props.isLoggedIn) {
            if (props.userToken === "guest") {
                props.dispatch(logout());
                history.push(Project.getPageUrl(AppPages.Login));
            } else if (props.userData.logoutUrl) {
                store.remove(StoreKeys.UserToken);
                store.remove(StoreKeys.Role);
                store.remove(StoreKeys.UserData);
                store.remove(StoreKeys.ApplicationData)
    
                window.location.href = props.userData.logoutUrl;
            } else {
                Ajax.post({
                    url: ApiUrl.Logout,
                    data: {},
                    success: function (response) {
                        props.dispatch(logout());
                        if (response.redirectUrl) {
                            window.location.href = response.redirectUrl;
                        } else {
                            history.push(Project.getPageUrl(AppPages.Login));
                        }
                    }
                })
            }
        } else {
            history.push(Project.getPageUrl(AppPages.Login));
        }
    }, []);// eslint-disable-line react-hooks/exhaustive-deps

    return <><div preloader=""><Spin size="large" /></div></>;
}

export default connect(state => ({
    userToken: state.userToken,
    isLoggedIn: state.isLoggedIn,
    userData: state.userData
}))(Logout);